export const MotivationFeature = {
  Avatars: 'Avatars',
  Games: 'Games',
  League: 'League',
  AvatarsSansParents: 'AvatarsSansParents'
};
